import {
  PRICE_L_PEAK_SEASON_WEEK,
  PRICE_L_PEAK_SEASON_SUN_THUR,
  PRICE_L_PEAK_SEASON_THUR_SUN,
  PRICE_L_LOW_SEASON_WEEK,
  PRICE_L_LOW_SEASON_SUN_THUR,
  PRICE_L_LOW_SEASON_THUR_SUN,
  PRICE_L_LOW_SEASON_DAY,
  PRICE_S_PEAK_SEASON_WEEK,
  PRICE_S_PEAK_SEASON_SUN_THUR,
  PRICE_S_PEAK_SEASON_THUR_SUN,
  PRICE_S_LOW_SEASON_WEEK,
  PRICE_S_LOW_SEASON_SUN_THUR,
  PRICE_S_LOW_SEASON_THUR_SUN,
  PRICE_S_LOW_SEASON_DAY,
  PRICE_F_PEAK_SEASON_WEEK,
  PRICE_F_PEAK_SEASON_DAY,
  PRICE_F_LOW_SEASON_WEEK,
  PRICE_F_LOW_SEASON_DAY
} from "../constants.js"

export const ENGLISH_TRANSLATIONS = {
    text: {
        home: 'Home',
        email: "Email",
        welcome_to: "Welcome to",
        hjortronvagen: "Hjortronvägen",
        rent_a_cabin: "Rent a cabin in",
        beautiful_salen: "beautiful Sälen",
        email_taken: "The email you have entered is already taken. If this is your email, contact us.",
        general_error: "Something went wrong. Try again later. If this keeps happening, contact us.",
        Continue: "Continue",
        Continue_header: "Continue",
        Book_now: "Book now!",
        Logout: "Logout",
        salen: "Sälen",
        salen_info_text: "Rent a cabin in Sälen, Dalarna! \
        In Sälen there is something for everyone. In the summer, you can go hiking, fishing, bathing, biking etc. \
        In the winter you can go skiing, sledding, snowmobile riding and much more. \
        In addition to these seasonal activities you can also find bath houses, cinemas, spas and restaurants \
        The cabin is located in the area Högfjället, on",
        Hotel: "Hotel",
        Location: "Location",
        more_info: "More info",
        more_info_and_pictures: "More info and pictures",
        small_cabin: "Small cabin",
        large_cabin: "Large cabin",
        family_cabin: "Family cabin",
        small_cabin_info_short: "The smaller cabin with four beds, ca 50 m², living room with kitchen area, one sleeping loft, one bathroom.",
        large_cabin_info_short: "The larger cabin with six beds, ca 70 m², living room, kitchen, two bedrooms, one bathroom.",
        contact_us: "Contact us!",
        contact_us_text: "Contact us if you have any questions regarding cabins or booking!",
        admin: "Admin",
        bookings: "Bookings",
        book: "Book",
        book_text_short: "Do you already know everything you need to know? Go directly to the booking page!",
        book_family_cabin: "Click here to book the family cabin!",
        email_validation_text: "You need to enter a valid email.",
        email_address: "Email address",
        enter_email: "Enter email",
        phone: "Phone number",
        enter_phone: "Enter phone number",
        first_name: "First name",
        enter_first_name: "Enter first name",
        last_name: "Last name",
        enter_last_name: "Enter last name",
        cabin: "Cabin",
        select_cabin: "Select cabin",
        date: "Date",
        dates: "Dates",
        start_date: "Start date",
        end_date: "End date",
        more: "More",
        date_validation_text_peak_season: "During peak season you can only select thursdays or sundays. If you want to book these days please send \
                        a request to hjortronvagen15@gmail.com.",
        date_validation_text_holidays: "During holidays (sportlov, vasaloppsveckan, easter, easter break, christmas and new years) you can rent full weeks only. If you wish to rent fewer days, you will still be required to pay for the full week. If this is the case, please make a note in the booking with the dates you wish to book. We will then correct the dates in the booking.",
        date_validation_text_minimum: "One night minimum",
        book_login_text_1: "Book easily and keep track of your bookings by",
        book_login_text_2: "creating an account",
        book_login_text_3: ". Do you already have an account?",
        book_login_text_4: "Login!",
        date_overlaps_error: "Dates overlap with existing booking",
        memory_note: "Is there anything you want us to know?",
        message: "Message",
        enter_memory_note: "Enter note",
        users: "Users",
        profile: "Profile",
        contacted: "Contacted",
        not_contacted: "Not contacted",
        payed: "Payed",
        unpayed: "Unpayed",
        name: "Name",
        weeks: "Weeks",
        extra_info: "Extra info",
        note: "Note",
        created: "Created",
        user_type: "User type",
        show_old_bookings: "Show old bookings",
        edit_user: "Edit user",
        password: "Password",
        enter_password: "Enter password",
        repeat_password: "Repeat password",
        standard: "Standard",
        family: "Family",
        familyplus: "Owner",
        save: "Save",
        send: "Send",
        delete: "Delete",
        send_confirmation_email: "Send confirmation email",
        send_key_email: "Send lockbox code email",
        send_payment_reminder_email: "Send payment reminder email",
        show_confirmation: "Show booking confirmation",
        booking_confirmation: "Booking confirmation",
        saved: "Saved",
        passwords_not_match: "Passwords does not match",
        are_you_sure_delete_user: "Are you sure you want to delete this user?",
        delete_user: "Delete user",
        delete_cabin_price: "Delete price",
        cancel: "Cancel",
        are_you_sure_update_user: "Are you sure you want to update this user?",
        are_you_sure_delete_booking: "Are you sure you want to delete this booking?",
        are_you_sure_resend_confirmation_email: "Are you sure you want to resend the confirmation email? This will send an email to the email address in the booking.",
        are_you_sure_resend_key_email: "Are you sure you want to send the code to the lockbox? This will send an email to the email address in the booking.",
        are_you_sure_send_payment_reminder_email: "Are you sure you want to send a payment reminder? This will send an email to the email address in the booking.",
        are_you_sure_update_booking: "Are you sure you want to update this booking?",
        are_you_sure_update_cabin_price: "Are you sure you want to update this price?",
        are_you_sure_delete_cabin_price: "Are you sure you want to delete this price?",
        confirmation_email_sent: "Confirmation email was sent successfully",
        confirmation_email_fail: "Confirmation email failed to send",
        key_email_sent: "The code email was sent successfully",
        key_email_fail: "The code email failed to send",
        payment_reminder_email_sent: "The payment reminder email was sent successfully",
        payment_reminder_email_fail: "The payment reminder email failed to send",
        delete_booking: "Delete booking",
        select_user: "Select user",
        user: "User",
        edit_booking: "Edit booking",
        are_you_sure_delete_profile: "Are you sure you want to delete your profile?",
        are_you_sure_update_profile: "Are you sure you want to update your profile?",
        register_user: "Register user",
        forgot_password: "Forgot password",
        username: "Username",
        enter_username: "Enter username",
        terms_of_condition: "I accept that my information is saved until I delete my account. I also accept that my information may be used to contact me regarding my bookings.",
        terms_of_condition_booking: "I accept that the information I have provided is saved. I also accept that my information may be used to contact me regarding my booking. You can contact us if you want to delete all your information.",
        reset_code: "Reset code",
        enter_reset_code: "Enter reset code",
        new_password: "New password",
        forgot_password_text: "We will send you a reset code to your email which you can use in the next step. If you already have a reset code,",
        click_here: "click here",
        reset_password: "Reset password",
        send_code: "Send code",
        password_has_been_reset: "Your password has been reset. You can now login with your new password.",
        login: "Login",
        back: "Back",
        edit_profile: "Edit profile",
        optional: "optional",
        notes: "Notes",
        price: "Price",
        enter_price: "Enter price",
        sek: "SEK",
        wrong_credentials: "Wrong username or password",
        search: "Search",
        night: "night",
        nights: "nights",
        your_information: "Your details",
        additional_information: "Additional information",
        booking: "Booking",
        desired_dates: "Which dates would you like to book?",
        located_at: "Located at",

        cabin_read_more: "Cabin information",
        booking_payment_information: "Payment is made through bank transfer. More information about this can be found in your booking confirmation after this step. The booking is reserved after this step, and confirmed upon payment. You can contact hjortronvagen15@gmail.com to cancel the booking during the reservation duration without any cost.",
        small_cabin_short_description: "1 sleeping loft, 4 beds",
        large_cabin_short_description: "2 bedrooms, 6 beds",
        family_cabin_short_description: "6 beds",
        available_cabins: "Select cabin",
        select_dates: "Select dates",
        not_available: "Not available",
        not_available_singular: "Not available",
        select: "Select",

        weeks_input_info: "Weeks (enter as comma separated numbers, e.g. 1,2,3)",
        enter_weeks: "Enter weeks",
        enter_name: "Enter name",
        edit_price: "Edit price",
        create_price: "Create price",
        price_day: "Price per day",
        price_week: "Price per week",
        price_sun_to_thur: "Price for sunday to thursday",
        price_thur_to_sun: "Price for thursday to sunday",
        create: "Create",
        weeks_format_error: "Weeks have incorrect formatting",
        display_name: "Display name",
        display_name_en: "Display name (english)",
        block_partial_periods: "Block partial periods",
        block_partial_periods_info_text: "If this is checked, users will only be able to book thursdays and sundays for this period",

        // Family info texts
        info_to_family: "Info to family",
        info_family_header_1: "Prices for family can be found under each cabin's section. As well as being calculated when making a booking.",
        dec_to_apr: "december-april",
        per_week_1: "1 week = " + PRICE_F_PEAK_SEASON_WEEK + " SEK",
        per_day_1: "Per day = " + PRICE_F_PEAK_SEASON_DAY + " SEK",
        additional_guests_1: "If you have friends who stays in the same cabin as you another days charge is added to the total price. Check the box for bringing friends to get a correct calculation of the price.",
        may_to_nov: "may-november",
        per_week_2: "1 week = " + PRICE_F_LOW_SEASON_WEEK + " SEK",
        per_day_2: "Per day = " + PRICE_F_LOW_SEASON_DAY + " SEK",
        additional_guests_2: "If you have friends who stays in the same cabin as you another" + PRICE_F_LOW_SEASON_DAY + " SEK is added on the total price. Write in the notes when you book that you are bringing friends.",
        about_family_apartment: "About the family apartment",
        about_family_apartment_text: "This is first and foremost for the owners of the cabin. If you want to rent this you need to check with one of the owners. Alternatively you can email",
        about_family_apartment_text_2: "Alway leave the key in the lockbox when leaving the family apartment.",

        // Cabin texts
        the_cabin: "The cabin",
        l_apartment_text: "Our larger cabin, at around 70 m², is dividen in two floors. On the first floor you will find a spacious hallway, a bathroom with a shower and wc, a kitchen and a living room. \
        The kitchen is fully equipped with an oven, stove, fridge, freezer, dishwasher, microwave oven, coffee maker and an electric kettle. \
        In the living room you will find a TV (no cable) and a large couch where everyone can sit and hang out. \
        On the second floor there are two bedrooms. The larger bedroom has foor beds while the smaller has two (90cm). There are also two extra beds.",
        transport: "Transport",
        transport_text: "Thanks to the practical location of the cabin, you can easily take part of what Sälen has to offer, even if you don't have a car. Only a short walk of a couple of minutes will take you to Gammelgården. \
        Gammelgården. Here you can enjoy food and drinks in a cozy environment. Next to Gammelgården, by the road, there is a bus station where the bus from Mora stops. From the same bus stop you can take the ski buses that will take you to the different spot of Sälen. \
        If the bus is not to your liking, here you can also find a ski lift that will take you to Högfället as well as a ski slope that will take you to Lindvallen.",
        other: "Other",
        other_text: "Checkin on arrival day is from 14:00. Chekout on departure day is at 11:00. \
        Cleaning is not included. Pets and smoking are not allowed. All people in the party must be 18 or above if not accompanied by a parent. \
        If you wish to rent during holidays (sportlov, vasaloppsveckan, easter, easter break, christmas and new years) you can only rent whole weeks. You can stay for only a few days, but you will still have to pay for the whole week.",
        
        f_apartment_text: "You already know everything about this cabin!",

        peak_season_weeks: "Peak season weeks 1, 7-10, 15-18, 52",
        low_season_weeks: "Low season weeks are the ones not mentioned above",
        prices: "Prices",
        income: "Income",
        peak_season: "Peak season",
        low_season: "Low season",
        l_peak_season_1: PRICE_L_PEAK_SEASON_WEEK + " SEK sunday to sunday",
        l_peak_season_2: PRICE_L_PEAK_SEASON_SUN_THUR + " SEK sunday to thursday",
        l_peak_season_3: PRICE_L_PEAK_SEASON_THUR_SUN + " SEK thursday to sunday",
        l_low_season_single_day: PRICE_L_LOW_SEASON_DAY + " SEK per day",
        l_low_season_1: PRICE_L_LOW_SEASON_WEEK + " SEK sunday to sunday",
        l_low_season_2: PRICE_L_LOW_SEASON_SUN_THUR + " SEK sunday to thursday",
        l_low_season_3: PRICE_L_LOW_SEASON_THUR_SUN + " SEK thursday to sunday",
        
        s_apartment_text: "This is our smaller cabin, at around 70 m². On the first floor you will find a hallway, a bathroom with a shower and wc, a kitchen and a living room. \
        The kitchen is fully equipped with an oven, stove, fridge, freezer, dishwasher, microwave oven, coffee maker and an electric kettle. \
        In the living room you will find a TV (no cable), a couch and a couple of chairs. \
        On the sleeping loft there are four beds (90cm).",

        s_peak_season_1: PRICE_S_PEAK_SEASON_WEEK + " SEK sunday to sunday",
        s_peak_season_2: PRICE_S_PEAK_SEASON_SUN_THUR + " SEK sunday to thursday",
        s_peak_season_3: PRICE_S_PEAK_SEASON_THUR_SUN + " SEK thursday to sunday",
        s_low_season_single_day: PRICE_S_LOW_SEASON_DAY + " SEK per day",
        s_low_season_1: PRICE_S_LOW_SEASON_WEEK + " SEK sunday to sunday",
        s_low_season_2: PRICE_S_LOW_SEASON_SUN_THUR + " SEK sunday to thursday",
        s_low_season_3: PRICE_S_LOW_SEASON_THUR_SUN + " SEK thursday to sunday",

        // Cabin texts end

        sek_sun_to_sun: " SEK sunday to sunday",
        sek_sun_to_thur: " SEK sunday to thursday",
        sek_thur_to_sun: " SEK thursday to sunday",
        sek_per_week: " SEK per week",
        sek_per_day: " SEK per day",

        page_not_found: "The page was not found",
        friends_included: "I have friends with me",
        friends_included_admin: "Has friends with them (only relevant for family)",
        enter_information: "Enter information manually",
        me: "My user",

        small_cabin_instructions: "The small cabin is the apartment on the left side of the house.",
        large_cabin_instructions: "The large cabin is the entrance on the front of the house, to the left.",

        from: "from",
        to: "to",
        kl: "at",
        booking_number: "Booking id",
        address: "Address",
        your_notes: "Your notes",

        booking_completed_intro_text_1: "Thank you for your booking. These dates are now reserved. Here are instructions regarding payment as well as your stay. You will also get this confirmation as an email, remember to also check your junk mail. If you have an account, you can always see your bookings in your profile.",
        booking_completed_intro_text_2: "If you have any further questions, please send an email to",
        booking_completed_intro_text_3: "If it is a question regarding your booking, please include the booking id.",
        
        booking_completed_payment_text_1: "Shall be deposited into",
        booking_completed_payment_text_2: "Account number",
        booking_completed_payment_text_3: "Write the name and dates of your booking in the payment.",
        booking_completed_payment_text_4: "The booking is confirmed when the payment has been registered on the account above.",
        booking_completed_payment_text_4_5: "Payment is preferably made right away but 1 month before check-in date at the latest.",
        booking_completed_payment_text_5: "If you cancel the booking more than 1 month in advance of you stay, the full rent will be returned.",
        booking_completed_payment_text_6: "If you cancel the booking less than 1 month in advance of your stay, 50% of the rent will be returned.",

        booking_completed_arrival_text_1: "At arrival",
        booking_completed_arrival_text_2: "The car shall be parked on the parking lot on the other side of the road to allow for easy snow removal.",
        booking_completed_arrival_text_3: "The parking spot on the property is only for packing and unpacking.",
        booking_completed_arrival_text_4_large: "The large cabin is the entrance on the front of the house, to the left.",
        booking_completed_arrival_text_4_small: "The large cabin is the entrance on the front of the house, to the left.",
        booking_completed_arrival_text_5: "Keys are located in the black lockbox on the right side of the door.",
        booking_completed_arrival_text_6: "The code to the lockbox will be sent by email after final payment and 2 days before arrival.",
        
        booking_completed_leaving_text_1: "When leaving",
        booking_completed_leaving_text_2: "The cabin will be clean upon your arrival, and it shall be in the same condition when you leave.",
        booking_completed_leaving_text_3: "The kitchen shall be cleaned, all counter tops, oven, fridge, dishwasher, microwave-oven shall be cleaned.",
        booking_completed_leaving_text_4: "No food shall be left in the cabin.",
        booking_completed_leaving_text_5: "All waste shall be thrown at the waste site located in Köarskärsområdet.",
        booking_completed_leaving_text_6: "The floors shall be vacumed and mopped. There is equipment for cleaning in the cabin.",
        booking_completed_leaving_text_7: "Shake the carpets outside.",
        booking_completed_leaving_text_8: "The key is returned to the lockbox and shuffle the code.",
        
        booking_completed_outro_text_1: "We hope you will have a great stay in Sälen!",
        booking_completed_outro_text_2: "If any problems occur, please contact:",
        booking_completed_outro_text_3: "or send an email to",

        images: "Photos",
        show_images: "Show photos",
        hide_images: "Hide photos",
        information: "Information",

        username_change_info: "Note the login has been updated to use email instead of username. \
        If you have any issues with the login, or have forgotten your email, please contact us.",

        // ERROR TEXTS!
        
        something_went_wrong: "Something went wrong",
        something_went_wrong_try_later: "Something went wrong, please try again later",

        price_has_changed_warning: "Note that the price for the booking has been updated based on the changes. You can change the price manually if needed.",

        select_income_dates: "Select dates to see income.",
        income_family: "Income from family",
        income_external: "Income from externals",
        income_total: "Total income",
        select_year: "Select year",
        select_specific_dates: "Select specific dates",
        write_year: "Write which year you want to see income for.",
        placeholder_year: "Year",
        invalid_year: "Invalid year",
        selected_dates: "Selected dates",
    }
};